import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import store2 from 'store2';
import { Roles } from '../../../../common/src/enums/Roles';
import { useTranslate } from '../../mixins/translate/translate';
import { IStoreState } from '../../store/IStoreState';
import { EditPanelFilterSelectFromEndpoint } from '../common/editPanel/EditPanelFilterSelectFromEndpoint';
import { createMandatoryContext } from '../createMandatoryContext';
import { Topbar, TopbarLeft, TopbarCrumbActive, Content, TopbarRight } from '../elements';
import { DisplayMessage } from '../utils/displayMessage';

export const clientCompanyIdContext = createMandatoryContext<string>();

const queryStoreKey = 'clientCompanyDependentPage';

export function ClientCompanyDependentPage(props: { children: React.ReactNode; topBarTitle: string; topBarIcon: string }) {
    const translate = useTranslate();

    const userRole = useSelector((state: IStoreState) => state.authentication.role);
    const userCompanyId = useSelector((state: IStoreState) => state.authentication.companyId);

    const [clientCompanyId, setClientCompanyId] = React.useState<string | undefined>(
        (store2.get(queryStoreKey) as string) ?? (userRole === Roles.Administrator ? undefined : userCompanyId),
    );

    useEffect(() => {
        if (clientCompanyId) {
            store2.set(queryStoreKey, clientCompanyId);
        } else {
            store2.remove(queryStoreKey);
        }
    }, [clientCompanyId]);

    return (
        <clientCompanyIdContext.Provider value={clientCompanyId!}>
            <Topbar>
                <TopbarLeft>
                    <TopbarCrumbActive title={props.topBarTitle} icon={props.topBarIcon} />
                </TopbarLeft>
                {userRole === Roles.Administrator && (
                    <TopbarRight>
                        <EditPanelFilterSelectFromEndpoint
                            name="clientCompanyId"
                            value={clientCompanyId}
                            onChange={(value) => setClientCompanyId(value)}
                            placeholder={translate('common.selectItem', translate('common.client'))}
                            url="/api/clients"
                            mapResponseToOptions={(response: { json: { items: { id: string; name: string }[] } }) =>
                                response.json.items.map((i) => ({ text: i.name, value: i.id }))
                            }
                        />
                    </TopbarRight>
                )}
            </Topbar>
            <Content>
                {!clientCompanyId ? (
                    <DisplayMessage message={translate('label.pleaseFirstSelectAClient')} messageType="general" />
                ) : (
                    <>{props.children}</>
                )}
            </Content>
        </clientCompanyIdContext.Provider>
    );
}
